export const ADD_TOAST = "toastNotification/ADD_TOAST";
export const DISMISS_TOAST = "toastNotification/DISMISS_TOAST";
export const GET_STORAGE_TOAST = "toastNotification/GET_STORAGE_TOAST";
export const SET_STORAGE_TOAST = "toastNotification/SET_STORAGE_TOAST";
